/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

type AgentType = 'assistant';

type AgentStoreType = {
  showAgents: Record<AgentType, boolean>;
};

const initialState = (): AgentStoreType => ({
  showAgents: {
    assistant: false,
  },
});

export const useAgentStore = defineStore({
  id: 'agent',
  state: initialState,
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    hide(): void {
      Object.keys(this.showAgents).forEach((key) => {
        this.showAgents[key] = false;
      });
    },
    showAssistant(): void {
      this.showAgents.assistant = true;
    },
    hideAssistant(): void {
      this.showAgents.assistant = false;
    },
    toggleAssistant(): void {
      this.showAgents.assistant = !this.showAgents.assistant;
    },
  },
});
